// Globals
import React from 'react';

// Components
import { StyledItemWrapper, StyledItemHeader, StyledItemTitle, StyledButton } from './AdditionalInfoItemWrapperStyles';
import { EditIcon } from '@/icons';

interface AdditionalInfoItemWrapperProps {
  title: string;
  children: React.ReactNode;
  handleEditButton?: () => void;
  isEditable?: boolean;
}

const AdditionalInfoItemWrapper = ({
  title,
  children,
  handleEditButton,
  isEditable,
}: AdditionalInfoItemWrapperProps) => {
  return (
    <StyledItemWrapper>
      <StyledItemHeader>
        <StyledItemTitle>{title}</StyledItemTitle>
        {isEditable && (
          <StyledButton onClick={handleEditButton}>
            <EditIcon />
          </StyledButton>
        )}
      </StyledItemHeader>
      {children}
    </StyledItemWrapper>
  );
};

export default AdditionalInfoItemWrapper;
